/**
 * @class Oskari.mapframework.bundle.search.Flyout
 *
 * Renders the "search" flyout.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.search.Flyout',
/**
 * @static @method create called automatically on construction
 *
 * @param {Oskari.mapframework.bundle.search.SearchBundleInstance}
 * Instance reference to component that created the tile
 *
 */
function (instance) {
  this.instance = instance;
  this.container = null;

  // Actions that get added to the search result popup
  this.resultActions = {};
  this._searchContainer = null;
  this.tabsContainer = Oskari.clazz.create('Oskari.userinterface.component.TabContainer');
}, {
  /**
   * @method getName
   * @return {String} the name for the component
   */
  getName: function getName() {
    return 'Oskari.mapframework.bundle.search.Flyout';
  },
  /**
   * @method setEl
   * @param {Object} el
   *      reference to the container in browser
   * @param {Number} width
   *      container size(?) - not used
   * @param {Number} height
   *      container size(?) - not used
   *
   * Interface method implementation
   */
  setEl: function setEl(el, flyout, width, height) {
    this.container = el[0];
    if (!jQuery(this.container).hasClass('search')) {
      jQuery(this.container).addClass('search');
    }
    if (!flyout.hasClass('search')) {
      flyout.addClass('search');
    }
  },
  /**
   * @method startPlugin
   *
   * Interface method implementation, assigns the HTML templates
   * that will be used to create the UI
   */
  startPlugin: function startPlugin() {},
  /**
   * @method stopPlugin
   *
   * Interface method implementation, does nothing atm
   */
  stopPlugin: function stopPlugin() {},
  /**
   * @method getTitle
   * @return {String} localized text for the title of the flyout
   */
  getTitle: function getTitle() {
    return this.instance.getLocalization('title');
  },
  /**
   * @method getTabTitle
   * @return {String} localized text for the tab title
   */
  getTabTitle: function getTabTitle() {
    return this.instance.getLocalization('tabTitle');
  },
  /**
   * @method getDescription
   * @return {String} localized text for the description of the
   * flyout
   */
  getDescription: function getDescription() {
    return this.instance.getLocalization('desc');
  },
  /**
   * @method getOptions
   * Interface method implementation, does nothing atm
   */
  getOptions: function getOptions() {},
  /**
   * @method setState
   * @param {Object} state
   */
  setState: function setState(state) {
    this.getDefaultUI().setState(state);
  },
  /**
   * @method getState
   * @return {Object} state
   */
  getState: function getState() {
    return this.getDefaultUI().getState();
  },
  /**
   * @method createUi
   * Creates the UI for a fresh start
   */
  createUi: function createUi() {
    var me = this,
      sandbox = me.instance.getSandbox(),
      flyout = jQuery(this.container);
    me.tabsContainer.addTabChangeListener(function (previousTab, newTab) {
      // Make sure this fires only when the flyout is open
      if (!flyout.parents('.oskari-flyout.oskari-closed').length) {
        var searchInput = newTab.getContainer().find('input[type=text]');
        if (searchInput) {
          searchInput.focus();
        }
      }
      var eventBuilder = Oskari.eventBuilder('Search.TabChangedEvent'),
        previousTabId = previousTab ? previousTab.getId() : null,
        newTabId = newTab ? newTab.getId() : null,
        event = eventBuilder(previousTabId, newTabId);
      sandbox.notifyAll(event);
    });

    // Do not create the default UI if configured so
    if (this.instance.disableDefault) {
      return;
    }
    var defaultUI = this.getDefaultUI();
    defaultUI.createUi(me.container);
  },
  getDefaultUI: function getDefaultUI() {
    if (!this._defaultUI) {
      this._defaultUI = Oskari.clazz.create('Oskari.mapframework.bundle.search.DefaultView', this.instance);
    }
    return this._defaultUI;
  },
  focus: function focus() {
    this.getDefaultUI().focus();
  },
  /**
   *
   *
   */
  addTab: function addTab(item) {
    var me = this;
    var flyout = jQuery(me.container);
    // Change into tab mode if not already
    if (me.tabsContainer.panels.length === 0) {
      me.tabsContainer.insertTo(flyout);
      if (me.instance.disableDefault !== true) {
        var defaultPanel = Oskari.clazz.create('Oskari.userinterface.component.TabPanel');
        defaultPanel.setTitle(me.getTabTitle(), 'oskari_search_tabpanel_header');
        var defaultSearchEl = this.getDefaultUI().getContainer();
        defaultSearchEl.detach();
        defaultPanel.setContent(defaultSearchEl);
        defaultPanel.setId('oskari_search_tabpanel_header');
        defaultPanel.setPriority(me.instance.tabPriority);
        me.tabsContainer.addPanel(defaultPanel);
      }
    }
    var panel = Oskari.clazz.create('Oskari.userinterface.component.TabPanel');
    panel.setTitle(item.title, item.id);
    panel.setId(item.id);
    panel.setContent(item.content);
    panel.setPriority(item.priority);
    me.tabsContainer.addPanel(panel);
  },
  addSearchResultAction: function addSearchResultAction(action) {
    this.getDefaultUI().addSearchResultAction(action);
  },
  removeSearchResultAction: function removeSearchResultAction(name) {
    this.getDefaultUI().removeSearchResultAction(name);
  }
}, {
  /**
   * @static @property {String[]} protocol
   */
  protocol: ['Oskari.userinterface.Flyout']
});